const debug = false;

// SVG ICONS
const defaultIconSvg = `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"><style type="text/css">	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#3283CB;stroke-width:2;stroke-miterlimit:10;}</style><title>quadrato copy@1x</title><circle class="st0" cx="5" cy="5" r="3.8"/></svg>`;
const defaultIcon = new Image();
defaultIcon.src = 'data:image/svg+xml;base64,' + window.btoa(defaultIconSvg);
defaultIcon.width = 10;
defaultIcon.height = 10;


class SphygmomanometerChartRM {
    constructor(el, options) {
        if (debug) {
            console.log('SphygmomanometerChartRM: init in element with id \'' + el + '\'', options);
        }

        this.container = document.getElementById(el);
        if (!this.container) {
            console.error('SphygmomanometerChartRM: element with id \'' + el + '\' not found', this.container);
            return;
        }

        this.options = options;

        const { data = [], fromDate, toDate, animation = true, showLine = false, fill = false } = options;

        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el + '_canvas';

        var ctx = this.canvas.getContext("2d");

        // COLORS
        this.container.appendChild(this.canvas);

        if (debug) {
            console.debug('sphygmomanometer data', data);
        }

        this.convertData(options.data);
        ///this.convertData(data);

        // Setta le caratteristiche del grafico e i dati da visualizzare
        this.chart = new Chart(this.canvas.id, {
            type: 'scatter', // Cambia tipo in scatter per un grafico XY
            data: {
                datasets: [{
                    label: 'SYS vs DIA',
                    data: this.data1,
                    backgroundColor: 'rgba(0, 123, 255, 0.5)',
                    borderColor: 'rgba(0, 123, 255, 1)',
                    borderWidth: 1
                }],
            },

            options: {
                layout: {
                    padding: {
                        top: 25,
                    //     left: -10,
                    //     bottom: -10
                    }
                },
                animation: animation,
                scales: {
                    x: {
                        type: 'linear',
                        position: 'bottom',
                        title: {
                            display: true,
                            text: 'DIA (mmHg)',
                            color: '#269BEF'
                        },
                        ticks: {
                            color: '#269BEF' // Imposta il colore blu per i valori sull'asse x
                        },
                        min: 60,
                        max: 160,
                    },
                    y: {
                        type: 'linear',
                        title: {
                            display: true,
                            text: 'SYS (mmHg)',
                            color: '#269BEF'
                        },
                        ticks: {
                            color: '#269BEF' // Imposta il colore blu per i valori sull'asse x
                        },
                        min: 100,
                        max: 200,
                    },
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        position: 'nearest',
                        callbacks: {
                            title: function(tooltipItems) {

                                const date = new Date(tooltipItems[0].raw.timestamp * 1000); // Moltiplica per 1000 per convertire il timestamp da secondi a millisecondi
                                const day = String(date.getDate()).padStart(2, '0'); // Giorno (DD)
                                const month = String(date.getMonth() + 1).padStart(2, '0'); // Mese (MM)
                                const year = date.getFullYear(); // Anno (YYYY)
                                const hours = String(date.getHours()).padStart(2, '0'); // Ore (HH)
                                const minutes = String(date.getMinutes()).padStart(2, '0'); // Minuti (mm)

                                return `${day}/${month}/${year} ${hours}:${minutes}`;

                            },
                            label: function(tooltipItem) {
                                return "sys: "+tooltipItem.raw.x+"  dia: "+tooltipItem.raw.y+" bpm: "+tooltipItem.raw.bpm;
                            },
                            footer: (tooltipItems) => {
                                var text = '';
                                return text;
                            }
                        }
                    },
                },
            },
            plugins: [
                {
                    afterDatasetDraw: (chart) => {
                        let ctx = chart.ctx;
                        ctx.font = '12px Arial';
                        ctx.textBaseline = 'top';
                        ctx.textAlign = 'left';
                        ctx.fillStyle = 'black';
                        // Poi disegna i rettangoli
                        this.drawGreenRectangle(chart);
                        // Disegna prima i punti SYS/DIA
                        this.drawDataPoints(chart);

                    },
                },
                
            ],
        });

        if (debug) {
            console.debug('sphygmomanometer RM Style done', this.labels, this.data1, this.data2, this.data3);
        }
    }

    convertData(data) {
        this.data1 = [];

        // console.log('convertData', data);
        if (!!data && !!data.pas && !!data.pad) {
            for (const prop in data.pas) {
                this.data1.push({
                    x: data.pad[prop],
                    y: data.pas[prop],
                    bpm: data.bpm[prop],
                    timestamp: prop
                });
            }
        }
    }

    setData(data) {
        if (!this.chart || !this.chart.data) {
            console.error('Grafico non inizializzato.');
            return;
        }
        this.convertData(data);
        this.chart.data.labels = this.getLabels();
        this.chart.data.datasets[0].data = this.data1;
        this.chart.data.datasets[0].mylabel = 'SYS/DIA';
        this.chart.update();
    }

    getLabels() {
        const padValues = new Set(this.data1.map(d => d.x));
        return Array.from(padValues).sort((a, b) => a - b);
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }

    drawGreenRectangle(chart) {
        const ctx = chart.ctx;
        const x1 = 60; // Coordinata x nel grafico
        const y1 = 100; // Coordinata y nel grafico

        // Converti le coordinate del grafico in coordinate del canvas
        const canvasX1 = chart.scales.x.getPixelForValue(x1);
        const canvasY1 = chart.scales.y.getPixelForValue(y1);
        let canvasX2 = 0;
        let canvasY2 = 0;
        let rectWidth = 0;
        let rectHeight = 0;

        ctx.font = "bold 12px 'Helvetica Neue', Helvetica, Arial, sans-serif";

        ctx.textAlign = 'left';
        const leftTextMargin = 70;

        // Ipertensione stadio 3
        canvasX2 = chart.scales.x.getPixelForValue(160);
        canvasY2 = chart.scales.y.getPixelForValue(200);
        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;

        ctx.fillStyle = '#c41022';
        ctx.fillStyle = '#ffa3a3';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("IPERTENSIONE STADIO 3", leftTextMargin, canvasY2+ 10);

        // Ipertensione stadio 2
        canvasX2 = chart.scales.x.getPixelForValue(110);
        canvasY2 = chart.scales.y.getPixelForValue(180);
        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;

        ctx.fillStyle = '#ffcd94';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("IPERTENSIONE STADIO 2", leftTextMargin, canvasY2 + 10);


        // Ipertensione stadio 1
        canvasX2 = chart.scales.x.getPixelForValue(100);
        canvasY2 = chart.scales.y.getPixelForValue(160);
        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;
    
        ctx.fillStyle = '#ffdf9e';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("IPERTENSIONE STADIO 1", leftTextMargin, canvasY2 + 10);


        // Normale alta
        canvasX2 = chart.scales.x.getPixelForValue(90);
        canvasY2 = chart.scales.y.getPixelForValue(140);
        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;
    
        ctx.fillStyle = '#73c97b';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("NORMALE ALTA", leftTextMargin, canvasY2 + 4);

        // Normale
        canvasX2 = chart.scales.x.getPixelForValue(85);
        canvasY2 = chart.scales.y.getPixelForValue(130);

        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;
    
        ctx.fillStyle = '#86e37d';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("NORMALE", leftTextMargin, canvasY2 + 4);


        // Ottimale
        canvasX2 = chart.scales.x.getPixelForValue(80);
        canvasY2 = chart.scales.y.getPixelForValue(120);
        // Calcola le dimensioni del rettangolo nel canvas
        rectWidth = canvasX2 - canvasX1;
        rectHeight = canvasY2 - canvasY1;
    
        ctx.fillStyle = '#9aeb99';
        ctx.fillRect(canvasX1, canvasY1, rectWidth, rectHeight);
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText("OTTIMALE", leftTextMargin, canvasY2+ 10);
    }

    drawDataPoints(chart) {
        const ctx = chart.ctx;
        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);
        meta.data.forEach((element, index) => {
            const data = dataset.data[index];
            const x = element.x;
            const y = element.y;
            // Usa la defaultIcon per disegnare il punto SYS/DIA
            ctx.drawImage(defaultIcon, x - defaultIcon.width / 2, y - defaultIcon.height / 2, defaultIcon.width, defaultIcon.height);
        });
    }

    formatTimestamp(timestamp) {
        const date = new Date(timestamp * 1000); // Moltiplica per 1000 per convertire il timestamp da secondi a millisecondi
        const day = String(date.getDate()).padStart(2, '0'); // Giorno (DD)
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Mese (MM)
        const year = date.getFullYear(); // Anno (YYYY)
        const hours = String(date.getHours()).padStart(2, '0'); // Ore (HH)
        const minutes = String(date.getMinutes()).padStart(2, '0'); // Minuti (mm)
    
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
}

window.SphygmomanometerChartRM = SphygmomanometerChartRM;
